window.MediaLibrary = new function()
{
    this.vars = {
        popup_page: 1,
        token: jQuery('meta[name="csrf-token"]').attr('content')
    };

    this.init = function() {
        jQuery('.media-library .delete-form button[type="submit"]').click(function(event) {
            event.preventDefault();
            var message = 'Are you sure you want to delete these items? They will also be deleted from their post.';

            if(confirm(message) == true) {
                jQuery('.media-library .delete-form').submit();
            }
        });

        jQuery('.media-library .media-library-toolbar select[name="sort"]').change(function(event) {
            jQuery('.media-library .media-library-toolbar form').submit();
        });

        if(jQuery('body').hasClass('media_library_page')) {
            MediaLibrary.initInfiniteScroll();
        }

        jQuery(document).on('show.bs.modal','#media-library-modal', function () {
            ImagePreview.buildHtml();
        });

        jQuery(document).on('hide.bs.modal','#media-library-modal', function () {
            MediaLibrary.vars.popup_page = 1;
            jQuery('body').removeClass('cropping');
        });

        jQuery('body').on('click', '#media-library-modal .load-more', function(event) {
            event.preventDefault();
            var that = this;
            MediaLibrary.vars.popup_page++;
            
            $.ajax({
                url: '/users/media-library/loadmore?page=' + MediaLibrary.vars.popup_page,
                type: 'POST',
                data: {
                    page: MediaLibrary.vars.popup_page,
                    _token: MediaLibrary.vars.token
                },
                showloader: true,
                success: function(response) { 
                    jQuery('#media-library-modal .media-grid').append(response);

                    var name = jQuery('#media-library-modal .media-library-upload-form .image-preview').attr('data-name-short');
                    jQuery('#media-library-modal .more-loaded').each(function(index, el) {
                        jQuery(el).find('a').attr('data-name', name);
                        jQuery(el).removeClass('more-loaded');
                    });
                }
            });
        });

        jQuery('body').on('submit', '.media-library-upload-form', function(event) {
            event.preventDefault();

            if(jQuery('body').hasClass('cropping')) {
                return;
            }

            var src                 = jQuery('.media-library-upload-form .preview-image').attr('src');
            var input_name_original = jQuery('.media-library-upload-form .image-preview').data('name');
            var input_name_arr      = input_name_original.split('_media_library_upload');
            var input_name          = input_name_arr[0];
            var image_preview       = jQuery('input[name="'+input_name+'_media_library"]').closest('.image-preview');
            
            try {
                var file = jQuery('input#'+ input_name_original)[0].files;

                if(file.length) {
                    if(file[0].type == 'image/gif') {
                        const fileInput    = document.querySelector('#' + input_name);
                        const dataTransfer = new DataTransfer();
                        dataTransfer.items.add(file[0]);
                        fileInput.files    = dataTransfer.files;
                    }

                    jQuery('#media-library-modal').modal('hide');

                    jQuery(image_preview).find('.add-image').html('<img class="preview-image" src="' + src + '" />');
                    jQuery(image_preview).find('.remove-image').css('display', '');
                    jQuery(image_preview).find('.add-image').addClass('edit');
                } else {
                    jQuery('.media-library-upload-form .remove-image').click();
                    alert('Please upload an image');
                }
            } catch(e) {
                alert('Please upload an image');
            }
        });

        var has_checked = false;
        jQuery('body').on('click', '.media-library .choose-media-from-library', function(event) {
            if(!$(event.target).closest(".image-popup").length && !$(event.target).closest(".video-modal").length) {
                if (jQuery(this).prev('input').prop('checked')) {
                    jQuery(this).removeClass('checked');
                    jQuery(this).prev('input').prop('checked', false);
                } else {
                    jQuery(this).addClass('checked');
                    jQuery(this).prev('input').prop('checked', true);
                }

                jQuery('.media-library .media-item').each(function(index, el) {
                    if(jQuery(this).find('input').prop('checked')) {
                        has_checked = true;
                        return false;
                    } else {
                        has_checked = false;
                    }
                });

                if(has_checked) {
                    jQuery('form.delete-form button[type="submit"]').show();
                } else {
                    jQuery('form.delete-form button[type="submit"]').hide();
                }
            }
        });
    };

    /**
     * Initialize infinite scroll on media library page
     */
    this.initInfiniteScroll = function() {
        jQuery('.media-library nav.media-library-pagination').hide();
        jQuery('.media-library .scrolling-pagination').jscroll({
            autoTrigger: true,
            padding: 0,
            nextSelector: 'nav.media-library-pagination .next',
            contentSelector: 'div.scrolling-pagination',
            callback: function() {
                jQuery('.media-library nav.media-library-pagination').remove();
            }
        });
    };
}

jQuery(document).ready(function($) {
    MediaLibrary.init();
});
